/**
 * The bell on each countdown's event ticket: shows whether daily reminders
 * are on (a dot while they aren't) and jumps straight to them in Settings.
 */
import { store } from "../state";
import { notificationReadiness } from "../notify";

export const BELL_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>`;

/** Settings reads this once and scrolls to the reminders section. */
export const JUMP_KEY = "cuntdown:jump";

export function bellHTML(extraClass = ""): string {
  return `<button type="button" class="cd-bell ${extraClass}" data-el="bell">${BELL_SVG}<span class="cd-bell-dot" aria-hidden="true"></span></button>`;
}

export function openReminderSettings() {
  try {
    sessionStorage.setItem(JUMP_KEY, "reminders");
  } catch {
    // private mode: Settings just opens at the top
  }
  location.hash = "#/settings";
}

/** Wires up the bell rendered by bellHTML(); returns its cleanup. */
export function mountBell(root: HTMLElement): () => void {
  const bell = root.querySelector<HTMLButtonElement>('[data-el="bell"]');
  if (!bell) return () => {};
  const paint = () => {
    const on = store.get().notifications.enabled && notificationReadiness() === "granted";
    bell.classList.toggle("is-on", on);
    bell.setAttribute("aria-label", on ? "Daily reminders are on. Change them" : "Daily reminders are off. Set them up");
  };
  paint();
  bell.addEventListener("click", openReminderSettings);
  const unsubscribe = store.subscribe(paint);
  return () => {
    bell.removeEventListener("click", openReminderSettings);
    unsubscribe();
  };
}
